export const convertPriceToNumber = (value: string | undefined): number =>
    parseFloat(value?.replace(/[^0-9.-]+/g, '') as string);
